/**
 * PushManagerPresenter
 * --
 *
 */

import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  InputFormTable,
  Text,
  Editor,
} from 'components';
import {
  Input,
  Button,
  Checkbox,
  Radio,
  Table,
  Image,
  Space,
  Flex,
  Tooltip,
} from 'antd';
import MessageAlert, { stringToMoneyFormat } from 'utils';
import plus_w from 'assets/plus_w.svg';
import {
  CloseOutlined,
  SearchOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';

const styles = {
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 20,
  },
  subTitle: {
    fontSize: 17,
    fontWeight: 500,
    lineHeight: '141%',
    marginBottom: 20,
  },
  button: {
    width: 80,
    height: 40,
    fontSize: 15,
    fontWeight: 600,
    margin: '0px 4px',
  },
  form: {
    input: {
      large: {
        width: 175,
        marginRight: 8,
      },
      medium: {
        width: 100,
        marginRight: 8,
      },
    },
    button: {
      marginRight: 8,
    },
    date: {
      width: 120,
    },
    text: {
      fontSize: 13,
      fontWeight: 400,
    },
  },

  filterWrap: {
    display: 'flex',
    flexDirection: 'column',
    // gap: 12,
  },
  filterItem: {
    display: 'flex',
    gap: 24,
    alignItems: 'stretch',
    borderBottom: '1px solid #DDDDDD',
  },
  filterLabel: {
    width: 150,
    background: '#F4F4F4',
    padding: '24px 10px',
    borderRight: '1px solid #DDDDDD',
  },
  filterValue: {
    flex: 1,
    padding: '24px 0px',
  },
};

/**----------------------------------------
 * [Component] PushManagerPresenter
 * ----------------------------------------
 */
const PushManagerPresenter = ({
  sendData,
  // userList,
  sendType,
  setSendType,
  onSendPush,
  onChangeData,
  onAddADTemplate,

  type,
  users,
  typeText,
  grades,
  setLoading,
  selectedUsers,
  onSelect,
  onSubmit,
  getEucKrByteLength,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const fileInputRef = React.useRef(null);
  const searchInput = React.useRef(null);
  // 회원 필터 목록
  const [userList, setUserList] = React.useState([...users]);
  const [searchedColumn, setSearchedColumn] = React.useState('');
  const [searchText, setSearchText] = React.useState('');
  // 선택된 필터
  const [filter, setFilter] = React.useState({});

  // console.log('userList ===>', userList);

  const handleTableSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleTableReset = (clearFilters, confirm) => {
    clearFilters();
    setSearchText('');
    confirm();
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`검색어를 입력해주세요`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleTableSearch(selectedKeys, confirm, dataIndex)
          }
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleTableSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            검색
          </Button>
          <Button
            onClick={() =>
              clearFilters && handleTableReset(clearFilters, confirm)
            }
            size="small"
            style={{
              width: 90,
            }}
          >
            초기화
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex.replace(/^processed_/, '').replace(/^expired_/, '')]
        ?.toString()
        ?.toLowerCase()
        ?.includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) => text,
  });

  // const sendData = React.useMemo(() => {
  //   return sendDataValue;
  // }, [sendDataValue]);
  /* ===== VARIABLE ===== */
  const FORM = {
    'push-manager': [
      {
        label: '제목',
        required: true,
        form: [
          {
            input: (
              <Flex gap={10} align="center">
                <Input
                  size="large"
                  placeholder="제목 입력"
                  style={{ width: 685 }}
                  name="title"
                  value={sendData.title}
                  onChange={(e) => onChangeData('title', e.target.value)}
                  showCount
                  count={{
                    max: 200,
                    strategy: (value) => getEucKrByteLength(value),
                  }}
                />
                <Button
                  type="default"
                  onClick={() => {
                    onAddADTemplate(type);
                  }}
                  size="middle"
                >
                  광고 적용하기
                </Button>
                <Tooltip
                  overlayStyle={{
                    maxWidth: 500,
                  }}
                  color="white"
                  title={
                    <Flex vertical align="center">
                      <p style={{ color: '#000' }}>
                        * 내용은 템플릿 관리 {'>'} 관리자 {'>'} 광고 템플릿에서
                        수정 가능합니다.
                      </p>
                      <a href="/#/message/template">이동하기</a>
                    </Flex>
                  }
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </Flex>
            ),
          },
        ],
      },
      {
        label: '메시지 내용',
        required: true,
        form: [
          {
            input: (
              <Input.TextArea
                rows={6}
                style={{ width: '100%' }}
                name="body"
                value={sendData.body}
                onChange={(e) => onChangeData('body', e.target.value)}
                showCount
                count={{
                  max: 1000,
                  strategy: (value) => getEucKrByteLength(value),
                }}
              />
            ),
            fullscreen: true,
          },
        ],
      },
    ],
    'sms-manager': [
      {
        label: '메세지 타입',
        required: true,
        form: [
          {
            input: (
              <Flex gap={10} align="center">
                <Radio.Group
                  options={[
                    { label: 'SMS', value: 'sms' },
                    { label: 'LMS', value: 'lms' },
                    { label: 'MMS', value: 'mms' },
                  ]}
                  value={sendData.type ?? 'sms'}
                  onChange={(e) => onChangeData('type', e.target.value)}
                />
                <Button
                  type="default"
                  onClick={() => {
                    onAddADTemplate(type);
                  }}
                  size="middle"
                >
                  광고 적용하기
                </Button>
                <Tooltip
                  overlayStyle={{
                    maxWidth: 500,
                  }}
                  color="white"
                  title={
                    <Flex vertical align="center">
                      <p style={{ color: '#000' }}>
                        * 내용은 템플릿 관리 {'>'} 관리자 {'>'} 광고 템플릿에서
                        수정 가능합니다.
                      </p>
                      <a href="/#/message/template">이동하기</a>
                    </Flex>
                  }
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </Flex>
            ),
          },
        ],
      },
      ...((sendData?.type ?? 'sms') !== 'sms'
        ? [
            {
              label: '메시지 제목',
              required: true,
              form: [
                {
                  input: (
                    <Input
                      style={{ width: '100%' }}
                      name="subject"
                      value={sendData.subject}
                      onChange={(e) => onChangeData('subject', e.target.value)}
                      showCount
                      count={{
                        max: 64,
                        strategy: (value) => getEucKrByteLength(value),
                      }}
                    />
                  ),
                  fullscreen: true,
                },
              ],
            },
          ]
        : []),
      {
        label: '메시지 내용',
        required: true,
        form: [
          {
            input: (
              <Input.TextArea
                rows={6}
                style={{ width: '100%' }}
                name="body"
                value={sendData.message}
                onChange={(e) => onChangeData('message', e.target.value)}
                maxLength={(sendData?.type ?? 'sms') === 'sms' ? 90 : 2000}
                showCount
                count={{
                  max: (sendData?.type ?? 'sms') === 'sms' ? 90 : 2000,
                  strategy: (value) => getEucKrByteLength(value),
                }}
              />
            ),
            fullscreen: true,
          },
        ],
      },
      ...(sendData?.type === 'mms'
        ? [
            {
              label: '파일',
              required: true,
              form: [
                {
                  input: sendData?.file ? (
                    <div style={{ position: 'relative', top: 0, left: 0 }}>
                      <Image src={URL.createObjectURL(sendData?.file)} />

                      <button
                        style={{
                          position: 'absolute',
                          top: -16,
                          right: -16,
                          cursor: 'pointer',
                          border: '1px solid #111111',
                          background: '#FFFFFF',
                          fontSize: 24,
                          width: 36,
                          height: 36,
                          borderRadius: '50%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                        onClick={() => onChangeData('file', null)}
                      >
                        <CloseOutlined />
                      </button>
                    </div>
                  ) : (
                    <div
                      style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        width: 100,
                        height: 100,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                      }}
                      onClick={() => fileInputRef.current.click()}
                    >
                      <img src={plus_w} alt="plus icon" />
                      <input
                        ref={fileInputRef}
                        id="upload"
                        type="file"
                        accept={'image/jpg, image/jpeg'}
                        onChange={(e) => {
                          const file = e.target.files[0];

                          if (file.size > 300 * 1024) {
                            MessageAlert.info(
                              '파일은 300KB이하로만 등록 가능합니다.'
                            );
                            return;
                          }

                          onChangeData('file', file);
                        }}
                      />
                    </div>
                  ),
                  fullscreen: true,
                },
              ],
            },
          ]
        : []),
    ],
    'email-manager': [
      {
        label: '제목',
        required: true,
        form: [
          {
            input: (
              <Input
                size="large"
                placeholder="제목 입력"
                style={{ width: 685 }}
                name="title"
                value={sendData.subject}
                onChange={(e) => onChangeData('subject', e.target.value)}
                maxLength={100}
                showCount
              />
            ),
          },
        ],
      },
      {
        label: '이메일 내용',
        required: true,
        form: [
          {
            input: (
              <Editor
                placeholder={'내용을 입력해주세요'}
                initialContent={sendData?.content}
                editorOnChange={(content) => onChangeData('content', content)}
                height={550}
              />
            ),
            fullscreen: true,
          },
        ],
      },
    ],
  };

  // NOTE: 테이블 컬럼
  const columns = [
    {
      title: '이름',
      dataIndex: 'user_name',
      width: 150,
      ...getColumnSearchProps('user_name'),
      render: (user_name) => user_name || '-',
    },
    {
      title: '연락처',
      dataIndex: 'user_phone',
      width: 150,
      render: (user_phone) => user_phone || '-',

      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
        close,
      }) => (
        <div
          style={{
            padding: 8,
          }}
          onKeyDown={(e) => e.stopPropagation()}
        >
          <Input
            ref={searchInput}
            placeholder={`검색어를 입력해주세요`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() =>
              handleTableSearch(selectedKeys, confirm, 'user_phone')
            }
            style={{
              marginBottom: 8,
              display: 'block',
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() =>
                handleTableSearch(selectedKeys, confirm, 'user_phone')
              }
              icon={<SearchOutlined />}
              size="small"
              style={{
                width: 90,
              }}
            >
              검색
            </Button>
            <Button
              onClick={() =>
                clearFilters && handleTableReset(clearFilters, confirm)
              }
              size="small"
              style={{
                width: 90,
              }}
            >
              초기화
            </Button>
          </Space>
        </div>
      ),
    },
    {
      title: '이메일',
      dataIndex: 'email',
      width: 300,
      ...getColumnSearchProps('email'),
      render: (email) => (email ? email : '-'),
    },
    {
      title: '푸시토큰',
      dataIndex: 'push',
      render: (text) => (
        <Text size={14} style={{ maxWidth: 150 }}>
          {text ? text : '-'}
        </Text>
      ),
    },
    {
      title: '등급',
      dataIndex: 'grade_name',
    },
    {
      title: '회원 여부',
      dataIndex: 'is_member',
    },
    {
      title: '푸시알림 동의 여부',
      dataIndex: 'push_notification',
    },
    {
      title: '프로모션/이벤트 알림 동의 여부',
      dataIndex: 'event_notification',
    },
    {
      title: '마케팅정보 수집 및 활용 동의 여부',
      dataIndex: 'marketing_consent',
    },
    {
      title: '혜택 및 광고성 정보 수신 동의 여부',
      dataIndex: 'terms_of_ad',
    },
    {
      title: '마케팅 목적의 개전정보 수집 및 이용 동의 여부',
      dataIndex: 'terms_of_marketing',
    },
  ];

  // NOTE: 필터 목록
  const FilterItems = React.useMemo(() => {
    const filterItems = [
      ...(grades && grades.length
        ? [
            {
              title: '등급',
              key: 'grade_id',
              children: grades,
            },
          ]
        : []),
      {
        title: '회원 여부',
        key: 'is_member',
        children: [
          {
            label: '회원',
            value: 'Y',
          },
          {
            label: '비회원',
            value: 'N',
          },
        ],
      },
      {
        title: '푸시알림 동의 여부',
        key: 'push_notification',
        children: [
          {
            label: '동의함',
            value: 'Y',
          },
          {
            label: '동의안함',
            value: 'N',
          },
        ],
      },
      {
        title: '프로모션/이벤트 알림 동의 여부',
        key: 'event_notification',
        children: [
          {
            label: '동의함',
            value: 'Y',
          },
          {
            label: '동의안함',
            value: 'N',
          },
        ],
      },
      {
        title: '마케팅정보 수집 및 활용 동의 여부',
        key: 'marketing_consent',
        children: [
          {
            label: '동의함',
            value: 'Y',
          },
          {
            label: '동의안함',
            value: 'N',
          },
        ],
      },
      {
        title: '혜택 및 광고성 정보 수신 동의 여부',
        key: 'terms_of_ad',
        children: [
          {
            label: '동의함',
            value: 'Y',
          },
          {
            label: '동의안함',
            value: 'N',
          },
        ],
      },
      {
        title: '마케팅 목적의 개전정보 수집 및 이용 동의 여부',
        key: 'terms_of_marketing',
        children: [
          {
            label: '동의함',
            value: 'Y',
          },
          {
            label: '동의안함',
            value: 'N',
          },
        ],
      },
    ];

    return filterItems;
  }, [grades]);

  // NOTE: 검색된 회원 목록
  const filterUserList = React.useMemo(() => {
    let arr = userList;

    if (searchText) {
      arr = arr.filter((user) =>
        searchedColumn === 'user_phone'
          ? user[searchedColumn]
              ?.replace(/-/g, '')
              ?.includes(searchText?.replace(/-/g, ''))
          : user[searchedColumn]?.includes(searchText)
      );
    }
    // console.log('searchText?.replace(/-/g, )', searchText?.replace(/-/g, ''));
    return arr;
  }, [userList, searchText, searchedColumn]);

  /* ===== FUNCTION ===== */
  /**
   * 회원 검색
   * @param {string} type
   */
  const handleSearchList = (type = 'search') => {
    setLoading(true);

    let arr = [];
    // 검색 초기화
    if (type === 'reset') {
      setFilter({});
      arr = users;
    }
    // 필터값에 따른 회원 필터
    else {
      const filterList = users?.filter((user) =>
        Object.entries(filter)?.every(([key, validValues]) =>
          validValues?.includes(user?.[key])
        )
      );

      arr = filterList;
    }

    setTimeout(() => {
      setLoading(false);
      setUserList(arr);
    }, 1000);
  };

  /**
   * 필터 체크 핸들러
   * --
   * @param {string} t
   * @param {array} v
   */
  const handleSelected = (t, v) => {
    setFilter((prev) => ({
      ...prev,
      [t]: v,
    }));
  };

  /* ===== HOOKS ===== */

  React.useEffect(() => {
    setUserList([...users]);
  }, [users]);

  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Title style={{ ...styles.title }}>
        {typeText[type.split('-')[0]]} 발송
      </Title>
      <Row>
        {/* === === */}
        <Col x={24}>
          <Content
            maxWidth={'100%'}
            // padding={20}
            borderRadius={4}
            style={{ marginBottom: 40 }}
          >
            <Row>
              <Col x={24}>
                {/* === 기본정보 === */}

                <Title style={{ ...styles.subTitle }}>발송 내용</Title>
                <InputFormTable form={FORM[type]} />

                {/* === 기본정보 끝 === */}
              </Col>
            </Row>
          </Content>
        </Col>

        <Col x={24}>
          <Content
            maxWidth={'100%'}
            // padding={20}
            borderRadius={4}
            style={{ marginBottom: 40 }}
          >
            <Title style={{ ...styles.subTitle }}>회원 검색</Title>

            {/* 검색 */}
            <div style={{ ...styles.filterWrap }}>
              {FilterItems.map((item, index) => (
                <div
                  key={`${item.key}_${index}`}
                  style={{
                    ...styles.filterItem,
                    ...(index === 0 ? { borderTop: '1px solid #DDDDDD' } : {}),
                  }}
                >
                  <div style={{ ...styles.filterLabel }}>
                    <Text weight={700} maxLine={3}>
                      {item.title}
                    </Text>
                  </div>
                  <div style={{ ...styles.filterValue }}>
                    <Checkbox.Group
                      options={item.children}
                      value={filter[item.key]}
                      onChange={(e) => handleSelected(item.key, e)}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div>
              <Content
                maxWidth={'100%'}
                padding={'24px 0px'}
                style={{
                  display: 'flex',
                  gap: 12,
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button size="large" onClick={() => handleSearchList('reset')}>
                  초기화
                </Button>
                <Button
                  size="large"
                  type="primary"
                  onClick={() => handleSearchList('search')}
                >
                  검색
                </Button>
              </Content>
            </div>

            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  marginBottom: 10,
                }}
              >
                <Text size={14} color={'#666666'}>
                  검색된 회원{' '}
                  <span style={{ fontWeight: 700, color: '#111111' }}>
                    {stringToMoneyFormat(filterUserList.length, '명')}
                  </span>
                </Text>

                <Text size={14} color={'#666666'}>
                  선택된 회원{' '}
                  <span style={{ fontWeight: 700, color: '#111111' }}>
                    {stringToMoneyFormat(selectedUsers.length, '명')}
                  </span>
                </Text>

                <Button onClick={() => onSelect('ALL', filterUserList)}>
                  검색된 회원 전체{' '}
                  {filterUserList.length === selectedUsers.length
                    ? '해제'
                    : '선택'}
                </Button>
              </div>
              {/* {console.log('filterUserList1212312', filterUserList)} */}
              <Table
                columns={columns}
                dataSource={filterUserList}
                rowSelection={{
                  type: 'checkbox',
                  onSelect: (record, selected, selectedRows, nativeEvent) => {
                    onSelect(selected ? 'checked' : 'unchecked', record);
                  },
                  onSelectAll: (selected, selectedRows, changeRows) => {
                    onSelect(
                      selected ? 'all-checked' : 'all-unchecked',
                      selectedRows
                    );
                  },
                  selectedRowKeys: selectedUsers?.map((user) => user?.key),
                  // getCheckboxProps: (record) => ({
                  //   user_name: record.user_name,
                  // }),
                }}
              />
            </div>
          </Content>
        </Col>

        {/* === === */}
        <Col x={24}>
          {/* === 버튼 === */}
          <Content maxWidth={'100%'} backgroundColor={'none'}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button
                size="large"
                style={{
                  ...styles.button,
                  background: 'var(--primary-color)',
                  color: '#FFFFFF',
                }}
                // onClick={onSendPush}
                onClick={() => onSubmit()}
              >
                발송
              </Button>
              <Button size="large" style={{ ...styles.button }}>
                취소
              </Button>
            </div>
          </Content>
          {/* === 버튼 끝 === */}
        </Col>
      </Row>
    </Content>
  );
};

export default PushManagerPresenter;
